import LayoutTypes from './LayoutTypes';
import update from 'immutability-helper';

import { STORAGE_KEYS } from '../../configs/AppConfig';
import StorageHelper from '../../utils/StorageHelper';

import merge from 'lodash/merge';

const initialState = merge(
  {

  },
  StorageHelper.getLocalObject(STORAGE_KEYS.layout)
);

export default function layoutReducer (state = initialState, action) {
  const {
    payload: {
      panelName,
      sidebarName,
      size,
      docked,
      visible,
      fixed,
      fullWidth,
      showBackdrop,
      props
    } = {}
  } = action;
  let newState = state;

  // prevent error when update a property of undefined (sample change visible mode of undefined sidebar)
  const { [panelName]: { [sidebarName]: existedSidebar } = {} } = state;
  if (!existedSidebar) {
    return newState;
  }

  switch (action.type) {
    case LayoutTypes.CHANGE_SIZE:
      newState = update(state, {
        [panelName]: { [sidebarName]: { size: { $set: size } } }
      });
      break;

    case LayoutTypes.CHANGE_MODE:
      newState = update(state, {
        [panelName]: { [sidebarName]: { docked: { $set: docked } } }
      });
      break;

    case LayoutTypes.CHANGE_VISIBILITY:
      newState = update(state, {
        [panelName]: { [sidebarName]: { visible: { $set: visible } } }
      });
      break;

    case LayoutTypes.CHANGE_HEADER_FIXED:
      newState = update(state, {
        [panelName]: { [sidebarName]: { fixed: { $set: fixed } } }
      });
      break;

    case LayoutTypes.CHANGE_HEADER_FULL_WIDTH:
      newState = update(state, {
        [panelName]: { [sidebarName]: { fullWidth: { $set: fullWidth } } }
      });
      break;

    case LayoutTypes.CHANGE_BACKDROP_VISIBLE:
      newState = update(state, {
        [panelName]: {
          [sidebarName]: { showBackdrop: { $set: showBackdrop } }
        }
      });
      break;

    case LayoutTypes.UPDATE_CONTENT_PROPS:
      newState = update(state, {
        [panelName]: { [sidebarName]: { $set: props } }
      });
      break;

    default:
      newState = state;
  }

  StorageHelper.setLocalObject(STORAGE_KEYS.layout, newState);
  return newState;
}
